import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import { PiCheck } from "react-icons/pi";
import Search from "../../assets/icons/search.svg";
import Modal2Table from "../table/Modal2Table";
import { motion } from "framer-motion";
import Pagination from "../Pagination";

const Brochure2Modal = ({ setModal, data }) => {
  const [showInst, setShowInst] = useState(false);
  const [inst, setInst] = useState("All");
  const [allSchoolData, setAllSchoolData] = useState([]);
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  const [alpha, setAlpha] = useState("All");

  const [filterLetter, setFilterLetter] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  console.log(loading);
  // PAGINATION STATES AND LOGIC
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [chunkSize] = useState(5);

  const totalPages = schools
    ? Math.ceil(schools.length / itemsPerPage)
    : allSchoolData && Math.ceil(allSchoolData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = allSchoolData.slice(startIndex, endIndex);

  const chunkStart = Math.floor((currentPage - 1) / chunkSize) * chunkSize;
  // const chunkEnd = chunkStart + chunkSize;

  const handleInst = (item) => {
    setInst(item.sectionTitle);
    setShowInst(false);
    setSchools(item.contents);
    setAlpha("All");
    setShowFilter(false);
  };

  const alphabets = [
    "All",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  // THIS IS TO HANDLE ALPHABETS FILTER
  const handleAlpha = (alphabet) => {
    if (alphabet === "All") {
      setAlpha(alphabet);
      setShowFilter(false);
    } else if (alphabet !== "All" && inst !== "All") {
      setAlpha(alphabet);
      setShowFilter(true);
      const filteredContents = allSchoolData.filter((item) =>
        item.instName.toLowerCase().startsWith(alphabet.toLowerCase())
      );
      setFilterLetter(filteredContents);
    } else if (alphabet !== "All" && inst === "All") {
      setAlpha(alphabet);
      setShowFilter(true);
      const filteredContents = allSchoolData.filter((item) =>
        item.instName.toLowerCase().startsWith(alphabet.toLowerCase())
      );
      setFilterLetter(filteredContents);
    }
  };

  // THIS HANDLES SEARCH RESULTS
  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);
    setShowFilter(true);
    const filteredContents = allSchoolData.filter((item) =>
      item.instName.toLowerCase().startsWith(searchValue.toLowerCase())
    );
    setFilterLetter(filteredContents);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const info = data.sections.flatMap((item) => item.contents);
        setAllSchoolData(info);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();

    // console.log(allSchoolData, schools);
  }, [inst, setAllSchoolData, data.sections]);

  return (
    <motion.div
      initial={{ scale: 0.5, opacity: 0 }}
      animate={{ scale: 1, opacity: [0.1, 0.1, 0.1, 0.3, 0.5, 0.7, 1] }}
      transition={{ duration: 0.7, ease: "easeIn" }}
      exit={{ opacity: 0, transition: { duration: 1.5, ease: "easeIn" } }}
      className="relative mb-10 w-full h-[95vh] z-50 bg-white pt-5 shadow-md rounded-xl md:pt-6 lg:-mt-24 mx-auto"
    >
      {/* TITLE */}
      <div className="flex items-start justify-between w-full px-3 md:px-5 md:items-center lg:px-7">
        <p className="text-[10px] text-[#101828] font-semibold w-[75%] md:text-[12px] lg:text-sm xl:text-base">
          LIST OF {data.pageTile}
        </p>
        <IoCloseOutline
          onClick={() => setModal(false)}
          className="text-xl lg:text-2xl xl:text-3xl"
        />
      </div>

      {/* HORIZONTAL LINE */}
      <div className="w-full mt-2.5 bg-[#DDE1E6] border-[1px] border-dashed lg:mt-3.5"></div>

      {/* CONTENT */}
      <div className="px-3 w-full overflow-y-auto max-h-[80vh] md:my-3 md:px-5 md:max-h-[78vh] lg:max-h-[77vh] lg:px-7 xl:my-4">
        {data.desc.map((item) => (
          <p className="text-[10px] text-[#101828] font-normal pt-2.5 md:text-[12px] md:leading-5 lg:text-[13px] lg:leading-[22px] xl:text-[15px] xl:leading-6">
            {item}
          </p>
        ))}

        <div className="flex items-start justify-between w-full mt-5 flex-wrap md:z-10 md:mt-6 xl:mt-7">
          {/*INSTITUITION* */}
          <div className="flex flex-col items-start w-full bg-white md:w-[58%] xl:w-[63%]">
            <p className="text-[11px] text-[#53545C] font-medium lg:text-xs xl:text-sm">
              Institution
            </p>
            <div className="flex flex-col items-center w-full py-[10px] px-3 mt-1 border-[1px] border-[#DDE1E6] rounded-md xl:py-3 xl:px-5 xl:rounded-lg">
              <div
                onClick={() => setShowInst(!showInst)}
                className="flex items-center justify-between w-full"
              >
                <p className="text-[10px] text-[#53545C] font-normal xl:text-sm">
                  {inst}
                </p>
                {showInst ? (
                  <SlArrowUp className="text-xs text-[#808080] ml-5 xl:text-sm" />
                ) : (
                  <SlArrowDown className="text-xs text-[#808080] ml-5 xl:text-sm" />
                )}
              </div>
              {showInst && (
                <div className="w-full">
                  {data.sections.map((item) => {
                    return (
                      <div
                        key={item.id}
                        onClick={() => handleInst(item)}
                        className="flex items-start justify-start w-full mt-3 md:items-center cursor-pointer"
                      >
                        <div className="flex items-center justify-center h-[14px] w-[14px] rounded-sm border-[1px] border-[#DDE1E6] xl:h-4 xl:w-4 xl:rounded">
                          {inst === item.sectionTitle && <PiCheck />}
                        </div>
                        <p className="text-[10px] text-[#53545C] font-normal ml-2 xl:text-sm">
                          {item.sectionTitle}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/*SEARCH*/}
          <div className="flex flex-col items-start mt-4 w-full bg-white md:w-[40%] md:mt-0 xl:w-[35%]">
            <p className="text-[11px] text-[#53545C] font-medium lg:text-xs xl:text-sm">
              Search
            </p>
            <div className="relative h-9  mt-1 w-full xl:h-11">
              <input
                className="border-[1px] rounded-md border-[#DDE1E6] h-full w-full bg-white text-[10px] text-[#53545C] font-normal pl-9 outline-[#25A249] 
                                        xl:text-sm xl:pl-12 xl:rounded-lg"
                placeholder="Search institution name"
                value={searchTerm}
                onChange={handleSearch}
              />
              <img
                className="absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5"
                src={Search}
                alt="search_icon"
              />
            </div>
          </div>
        </div>

        {/*ALPHABETS*/}
        <div className="flex items-center justify-start w-full flex-wrap mt-5 md:mt-6 lg:justify-between lg:mt-7 xl:mt-8">
          {alphabets.map((item) => {
            return (
              <div
                onClick={() => handleAlpha(item)}
                className={`flex items-center justify-center px-[8px] py-1 mr-[6px] my-[2px] cursor-pointer rounded-3xl md:mr-[11px] lg:mx-0
                                                                ${
                                                                  alpha ===
                                                                    item &&
                                                                  "border-[1px] border-[#25A249]"
                                                                }`}
              >
                <p
                  className={`text-[10px] font-medium xl:text-xs ${
                    alpha === item ? "text-[#25A249]" : "text-[#53545C]"
                  }`}
                >
                  {item}
                </p>
              </div>
            );
          })}
        </div>

        <div className="flex items-start justify-between w-full mt-6 md:items-center md:mt-5 xl:mt-6">
          <p className="text-[11px] font-semibold text-[#53545C] mr-6 md:text-[12px] lg:text-[13.5px] xl:text-base">
            {inst}
          </p>

          <div className="flex items-center justify-end">
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[12px]">
              Show
            </p>
            <div className="flex items-center justify-between px-[6px] py-[3px] border-[1px] border-[#DDE1E6] rounded mx-[6px] md:mx-2 xl:mx-3">
              <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
                8
              </p>
              <SlArrowDown className="text-[7px] ml-[10px] xl:ml-[14px] xl:text-[9px]" />
            </div>
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
              entries
            </p>
          </div>
        </div>

        {/*TABLE*/}
        <div className="flex flex-col items-start justify-center w-full h-full">
          <Modal2Table
            data={
              inst === "All" && !showFilter
                ? paginatedItems
                : inst !== "All" && !showFilter
                ? paginatedItems
                : showFilter && filterLetter
            }
          />

          {/* FILTERED SCHOOLS NOT FOUND */}
          {filterLetter.length === 0 && showFilter && (
            <div className="flex items-center justify-center w-full mt-24">
              <p className="text-[#25A249] font-medium">
                Filtered items not found...
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="absolute bottom-5 w-full px-3 md:px-5 lg:px-7">
        {!showFilter && (
          <Pagination
            setLoading={setLoading}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            chunkSize={chunkSize}
            chunkStart={chunkStart}
          />
        )}
      </div>
    </motion.div>
  );
};

export default Brochure2Modal;
